import React, { Component } from 'react';
import { Grid, Button, Select, MenuItem, TextField, Box } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { indigo } from '@material-ui/core/colors';
import * as actionTypes from '../../../store/NewPatient/actionType';
import { withRouter } from 'react-router-dom';
import RadioButton from '../../Radio-button/RadioButton';
import styles from './NewPatientQuestionnaire.module.css';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { withLang } from '../../../util/lang';
import { getWebAbsPath } from '../../../util/path';

export const teethGraph = [
    {
        margin: '352px 0px 0px 206px',
        width: 56,
    },
    {
        margin: '305px 0px 0px 211px',
        width: 59,
    },
    {
        margin: '253px 0px 0px 216px',
        width: 61,
    },
    {
        margin: '214px 0px 0px 230px',
        width: 59,
    },
    {
        margin: '178px 0px 0px 247px',
        width: 58,
    },
    {
        margin: '146px 0px 0px 272px',
        width: 48,
    },
    {
        margin: '118px 0px 0px 296px',
        width: 48,
    },
    {
        margin: '108px 0px 0px 328px',
        width: 49,
    },
    {
        margin: '108px 0px 0px 370px',
        deg: 'scaleX(-1)',
        width: 49,
    },
    {
        margin: '118px 0px 0px 402px',
        deg: 'scaleX(-1)',
        width: 48,
    },
    {
        margin: '146px 0px 0px 425px',
        deg: 'scaleX(-1)',
        width: 48,
    },
    {
        margin: '178px 0px 0px 444px',
        deg: 'scaleX(-1)',
        width: 58,
    },
    {
        margin: '214px 0px 0px 460px',
        deg: 'scaleX(-1)',
        width: 59,
    },
    {
        margin: '253px 0px 0px 474px',
        deg: 'scaleX(-1)',
        width: 61,
    },
    {
        margin: '305px 0px 0px 488px',
        deg: 'scaleX(-1)',
        width: 59,
    },
    {
        margin: '352px 0px 0px 497px',
        deg: 'scaleX(-1)',
        width: 56,
    },
    {
        margin: '431px 0px 0px 497px',
        deg: 'scaleX(-1) scaleY(-1)',
        width: 56,
    },
    {
        margin: '477px 0px 0px 488px',
        deg: 'scaleX(-1) scaleY(-1)',
        width: 59,
    },
    {
        margin: '523px 0px 0px 474px',
        deg: 'scaleX(-1) scaleY(-1)',
        width: 61,
    },
    {
        margin: '570px 0px 0px 460px',
        deg: 'scaleX(-1) scaleY(-1)',
        width: 59,
    },
    {
        margin: '604px 0px 0px 444px',
        deg: 'scaleX(-1) scaleY(-1)',
        width: 58,
    },
    {
        margin: '639px 0px 0px 425px',
        deg: 'scaleX(-1) scaleY(-1)',
        width: 48,
    },
    {
        margin: '663px 0px 0px 402px',
        deg: 'scaleX(-1) scaleY(-1)',
        width: 48,
    },
    {
        margin: '674px 0px 0px 370px',
        deg: 'scaleX(-1) scaleY(-1)',
        width: 49,
    },
    {
        margin: '674px 0px 0px 328px',
        deg: 'scaleY(-1)',
        width: 49,
    },
    {
        margin: '663px 0px 0px 296px',
        deg: 'scaleY(-1)',
        width: 48,
    },
    {
        margin: '639px 0px 0px 272px',
        deg: 'scaleY(-1)',
        width: 48,
    },
    {
        margin: '604px 0px 0px 247px',
        deg: 'scaleY(-1)',
        width: 59,
    },
    {
        margin: '570px 0px 0px 230px',
        deg: 'scaleY(-1)',
        width: 61,
    },
    {
        margin: '523px 0px 0px 216px',
        deg: 'scaleY(-1)',
        width: 61,
    },
    {
        margin: '477px 0px 0px 211px',
        deg: 'scaleY(-1)',
        width: 59,
    },
    {
        margin: '431px 0px 0px 206px',
        deg: 'scaleY(-1)',
        width: 58,
    },
];

const IndigoCheckbox = withStyles({
    root: {
        color: indigo[500],
        '&$checked': {
            color: indigo[600],
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

class NewPatientQuestionnaire extends Component {
    gainingSpaceCheckBox = [
        { name: 'crowding', label: this.get('questionnaire.crowding') },
        { name: 'deepBite', label: this.get('questionnaire.deepBite') },
        { name: 'spacing', label: this.get('questionnaire.spacing') },
        { name: 'classII', label: this.get('questionnaire.classII') },
        { name: 'ClassIIDivI', label: this.get('questionnaire.ClassIIDivI') },
        { name: 'classIII', label: this.get('questionnaire.classIII') },
        { name: 'unevenSmile', label: this.get('questionnaire.unevenSmile') },
        { name: 'openBite', label: this.get('questionnaire.openBite') },
        { name: 'overbite', label: this.get('questionnaire.overbite') },
        { name: 'other', label: this.get('questionnaire.other') },
    ];

    questionnaireTeethRadio = [
        { value: 'none', label: this.get('questionnaire.none') },
        { value: 'upper', label: this.get('questionnaire.upper') },
        { value: 'lower', label: this.get('questionnaire.lower') },
        { value: 'anterior', label: this.get('questionnaire.anterior') },
        { value: 'posterior', label: this.get('questionnaire.posterior') },
        // { value: 'all', label: this.get(':const.all') }
    ];

    gainingSpace = [
        { value: 'primary', label: this.get('questionnaire.primary') },
        { value: 'secondary', label: this.get('questionnaire.secondary') },
        { value: 'none', label: this.get(':const.none') },
    ];

    gainingSpaceRadioButtons = [
        { value: 'primary', label: this.get('questionnaire.primary') },
        { value: 'secondary', label: this.get('questionnaire.secondary') },
        { value: 'none', label: this.get(':const.none') },
        { value: 'clinicalSimulation', label: this.get('questionnaire.referToClinicalSimulation') },
    ];

    gainingSpaceListExpansion = [
        { value: 'primary', label: this.get('questionnaire.primary') },
        { value: 'secondary', label: this.get('questionnaire.secondary') },
        { value: 'none', label: this.get(':const.none') },
    ];

    overJetListButtons = [
        { value: 'maintain', label: this.get('questionnaire.maintain') },
        { value: 'improve1mm', label: this.get('questionnaire.improve1mm') },
        { value: 'improve2mm', label: this.get('questionnaire.improve2mm') },
        { value: 'improve3mm', label: this.get('questionnaire.improve3mm') },
        { value: 'improve4mm', label: this.get('questionnaire.improve4mm') },
        { value: 'improve5mm', label: this.get('questionnaire.improve5mm') },
        { value: 'clinicalSimulation', label: this.get('questionnaire.referToClinicalSimulation') },
    ];

    overBiteListButtons = [
        { value: 'maintain', label: this.get('questionnaire.maintain') },
        { value: 'improve1mm', label: this.get('questionnaire.improve1mm') },
        { value: 'improve2mm', label: this.get('questionnaire.improve2mm') },
        { value: 'improve3mm', label: this.get('questionnaire.improve3mm') },
        { value: 'improve4mm', label: this.get('questionnaire.improve4mm') },
        { value: 'improve5mm', label: this.get('questionnaire.improve5mm') },
        { value: 'clinicalSimulation', label: this.get('questionnaire.referToClinicalSimulation') },
    ];

    midLineListButtons = [
        { value: 'clinicalSimulation', label: this.get('questionnaire.referToClinicalSimulation') },
        { value: 'maintain', label: this.get('questionnaire.maintain') },
        { value: 'correctUpper', label: this.get('questionnaire.correctUpper') },
        { value: 'correctLower', label: this.get('questionnaire.correctLower') },
    ];

    crossBiteRadioButtons = [
        { value: 'maintain', label: this.get('questionnaire.maintain') },
        { value: 'improve', label: this.get('questionnaire.improve') },
        { value: 'clinicalSimulation', label: this.get('questionnaire.referToClinicalSimulation') },
    ];

    constructor(props) {
        super(props);
        this.state = {
            questionnaireTeethRadio: null,
            // questionnaireTeethUpper:false,
            // questionnaireTeethLower:false,
            // questionnaireTeethPosterior:false,
            // questionnaireTeethAnterior:false,
            questionTeethCheckedIndex: [],
        };
    }
    check = (index) => {
        if (this.props.mode !== 'view') this.props.handleDatacrossTeeth(index);
    };

    checkClinicalConditionShowOther() {
        let clinical_condition =
            this.props.clinical_condition.length > 0 ? this.props.clinical_condition.split`,`.map((x) => +x) : [];
        var otherIndex = this.gainingSpaceCheckBox.findIndex((elem) => elem.name == 'other');
        return clinical_condition.includes(otherIndex);
    }

    handleExtractionConcat(value) {
        this.props.handleDataExtractionConcat(value);
    }

    handleExapantionConcat(value) {
        this.props.handleDataExpansionConcat(value);
    }

    handleMidline(value) {
        // console.log(value)
    }

    handleClinicalCondition(index) {
        let clinical_condition =
            this.props.clinical_condition.length > 0 ? this.props.clinical_condition.split`,`.map((x) => +x) : [];
        let find_index = clinical_condition.indexOf(index);

        if (find_index > -1) {
            clinical_condition.splice(find_index, 1);
        } else {
            clinical_condition.push(index);
        }
        this.props.changeClinicalCondition(clinical_condition.join());
    }

    handleDataQuestionnaireTeeth(value) {
        this.setState({ questionnaireTeethRadio: value });
        switch (value) {
            case 'upper':
                //this.setState({questionnaireTeethUpper:!this.state.questionnaireTeethUpper})
                for (let i = 0; i < 16; i++) {
                    this.props.handleDatacrossTeeth(i, true);
                }
                break;
            case 'lower':
                //this.setState({questionnaireTeethLower:!this.state.questionnaireTeethLower})
                for (let i = 16; i < 32; i++) {
                    this.props.handleDatacrossTeeth(i, true);
                }
                break;
            case 'posterior':
                //this.setState({questionnaireTeethPosterior:!this.state.questionnaireTeethPosterior})
                for (let i = 0; i < 32; i++) {
                    if ((i >= 0 && i < 5) || (i >= 11 && i < 16) || (i >= 16 && i < 21) || (i >= 27 && i < 32)) {
                        this.props.handleDatacrossTeeth(i, true);
                    }
                }
                break;
            case 'anterior':
                //this.setState({questionnaireTeethAnterior:!this.state.questionnaireTeethAnterior})
                for (let i = 0; i < 32; i++) {
                    if ((i >= 5 && i < 11) || (i >= 21 && i < 27)) {
                        this.props.handleDatacrossTeeth(i, true);
                    }
                }
                break;

            case 'none':
                //this.setState({questionnaireTeethAnterior:!this.state.questionnaireTeethAnterior})
                this.props.teeth.map((v, index) => {
                    if (v.checked) {
                        this.props.handleDatacrossTeeth(index);
                    }
                });
                break;
        }
    }

    render() {
        const { classes } = this.props;
        const items = [];
        let clinical_condition =
            this.props.clinical_condition.length > 0 ? this.props.clinical_condition.split`,`.map((x) => +x) : [];
        return (
            <ul className={styles.list}>
                <li>{this.get('questionnaire.clinicalCondition')}</li>
                <Grid container>
                    {/* <Grid item md={9}> */}
                    {this.gainingSpaceCheckBox.map((v, index) => (
                        <Grid item xs={4} key={v.name}>
                            <FormControlLabel
                                key={v.name}
                                control={
                                    <Checkbox
                                        name={v.name}
                                        checked={clinical_condition.includes(index) ? true : false}
                                        readOnly={this.props.mode === 'view'}
                                        onChange={() => this.handleClinicalCondition(index)}
                                    />
                                }
                                label={v.label}
                            />
                        </Grid>
                    ))}
                    {this.checkClinicalConditionShowOther() ? (
                        <TextField
                            id="other_comment"
                            className={styles.textField}
                            value={this.props.clinicalConditionComment ?? ''}
                            onChange={({ target: { value } }) =>
                                this.props.mode !== 'view' && this.props.handleClinicalConditionComment(value)
                            }
                            margin="normal"
                            variant="outlined"
                            multiline
                            rows={3}
                            placeholder={this.get('questionnaire.other')}
                        />
                    ) : (
                        ''
                    )}
                </Grid>
                <li>{this.get('questionnaire.selectDentition')}</li>

                {this.props.mode !== 'view' &&
                    this.questionnaireTeethRadio.map((value) => {
                        return (
                            <Box m={1} display="inline-block">
                                <Button
                                    onClick={this.handleDataQuestionnaireTeeth.bind(this, value.value)}
                                    variant="contained"
                                    color="primary"
                                >
                                    {value.label}
                                </Button>
                            </Box>
                        );
                    })}

                {/*
          <FormControlLabel
          control={<IndigoCheckbox checked={this.state.questionnaireTeethUpper} onChange={() => {this.handleDataQuestionnaireTeeth('upper')}} name="checkedG" />}
          label="Upper"
          />

          <FormControlLabel
          control={<IndigoCheckbox checked={this.state.questionnaireTeethLower} onChange={() => {this.handleDataQuestionnaireTeeth('lower')}} name="checkedG" />}
          label="Lower"
          />

          <FormControlLabel
          control={<IndigoCheckbox checked={this.state.questionnaireTeethAnterior} onChange={() => {this.handleDataQuestionnaireTeeth('anterior')}} name="checkedG" />}
          label="Anterior"
          />

          <FormControlLabel
          control={<IndigoCheckbox checked={this.state.questionnaireTeethPosterior} onChange={() => {this.handleDataQuestionnaireTeeth('posterior')}} name="checkedG" />}
          label="Posterior"
          />
        */}

                <div className={styles.toothImages}>
                    {/* {
          this.props.teeth.map((value,index)=>(
            <div key={index} className={styles.toothImage} onClick={() => this.check(index)}>
            <img src={`/img/tooth/${value.name}`} />
            {value.checked && <img src="/img/tooth/check.png" />}
            </div>
          ))
        } */}
                    <div
                        style={{
                            width: 800,
                            height: 800,
                            'margin-top': '10px',
                            position: 'relative',
                            backgroundRepeat: 'no-repeat',
                            backgroundImage: `url("${getWebAbsPath('/img/newTeeth/permanentTeeth.png')}")`,
                        }}
                    >
                        {/* <img src="/img/newTeeth/permanentTeeth.png" style={{width: 800}}/> */}
                        {teethGraph.map((v, i) => (
                            <div key={i}>
                                <img
                                    src={getWebAbsPath(`/img/newTeeth/t${i + 1}.png`)}
                                    style={{
                                        position: 'absolute',
                                        margin: v.margin,
                                        transform: `${v.deg}`,
                                        transformOrigin: '50% 50%',
                                        width: v.width,
                                    }}
                                    onClick={() => this.check(i)}
                                />
                                {this.props.teeth[i].checked && (
                                    <img
                                        src={getWebAbsPath('/img/tooth/check.png')}
                                        style={{
                                            position: 'absolute',
                                            margin: v.margin,
                                            width: v.width,
                                        }}
                                        onClick={() => this.check(i)}
                                    />
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                <li>{this.get('questionnaire.gainSpaceMethod')}</li>
                <div className={styles.radioWrapper}>
                    <RadioButton
                        label={this.get('questionnaire.extractionWhich')}
                        ariaLabel="Extraction"
                        name="extraction"
                        disabled={this.props.mode === 'view'}
                        value={this.props.extraction}
                        parent_name="extraction"
                        radios={this.gainingSpace}
                        handleExtractionConcat={(value) => this.handleExtractionConcat(value)}
                        extractionConcat={this.props.extractionConcat}
                        handleChange={(e) => {
                            this.props.handleDataExtraction(e.target.value);
                        }}
                    />

                    <RadioButton
                        label={this.get('questionnaire.expansion')}
                        ariaLabel="Expansion"
                        name="expansion"
                        value={this.props.expansion}
                        disabled={this.props.mode === 'view'}
                        parent_name="expansion"
                        radios={this.gainingSpaceListExpansion}
                        handleExapantionConcat={(value) => this.handleExapantionConcat(value)}
                        expansionConcat={this.props.expansionConcat}
                        handleChange={(e) => {
                            this.props.handleDataExpansion(e.target.value);
                        }}
                    />

                    {/*
          <Grid container>
            <Grid item md={3}><p className={styles.listHeading}>Expansion</p></Grid>
            <Grid item md={3}>
             <Select className={styles.optionLists}
             value={this.props.expansion}
             onChange = {(event) => this.props.handleDataExpansion(event.target.value)}>
                {
                  gainingSpaceListExpansion.map(v=>(
                      <MenuItem value={v.value} key={v.value}>{v.label}</MenuItem>
                   ))
                }
            </Select>
            </Grid>
          </Grid>
        */}
                    <RadioButton
                        label={this.get('questionnaire.interproximalReduction')}
                        ariaLabel="Interproximal Reduction"
                        name="interproximalReduction"
                        disabled={this.props.mode === 'view'}
                        value={this.props.interproximalReduction}
                        radios={this.gainingSpaceRadioButtons}
                        handleChange={(e) => {
                            this.props.handleDataInterproximalReduction(e.target.value);
                        }}
                    />

                    <RadioButton
                        label={this.get('questionnaire.distalization')}
                        ariaLabel="Distalization"
                        name="distalization"
                        disabled={this.props.mode === 'view'}
                        value={this.props.distalization}
                        radios={this.gainingSpaceRadioButtons}
                        handleChange={(e) => {
                            this.props.handleDataDistalization(e.target.value);
                        }}
                    />

                    <RadioButton
                        label={this.get('questionnaire.proclination')}
                        ariaLabel="Proclination"
                        name="proclination"
                        disabled={this.props.mode === 'view'}
                        value={this.props.proclination}
                        radios={this.gainingSpaceRadioButtons}
                        handleChange={(e) => {
                            this.props.handleDataProclination(e.target.value);
                        }}
                    />

                    {/*
          <RadioButton label="Refer to treatment simulation"
            ariaLabel="Refer to treatment simulation"
            name="treatmentSimulation"
            value={this.props.treatmentSimulation}
            radios={gainingSpace}
            handleChange={(e) => {
              this.props.handleDataTreatmentSimulation(e.target.value)
            }}
          />
        */}
                </div>

                <li>{this.get('questionnaire.overjet')}</li>
                <div className={styles.radioWrapper}>
                    <Select
                        style={{ width: '25%' }}
                        value={this.props.overJet}
                        readOnly={this.props.mode === 'view'}
                        onChange={(event) =>
                            this.props.mode !== 'view' && this.props.handleDataOverJet(event.target.value)
                        }
                    >
                        {this.overJetListButtons.map((v) => (
                            <MenuItem value={v.value} key={v.value}>
                                {v.label}
                            </MenuItem>
                        ))}
                    </Select>
                </div>

                <li>{this.get('questionnaire.overbite')}</li>
                <div className={styles.radioWrapper}>
                    <Select
                        style={{ width: '25%' }}
                        value={this.props.overBite}
                        readOnly={this.props.mode === 'view'}
                        onChange={(event) =>
                            this.props.mode !== 'view' && this.props.handleDataoverBite(event.target.value)
                        }
                    >
                        {this.overJetListButtons.map((v) => (
                            <MenuItem value={v.value} key={v.value}>
                                {v.label}
                            </MenuItem>
                        ))}
                    </Select>
                </div>

                <li>{this.get('questionnaire.midline')}</li>

                <div className={styles.radioWrapper}>
                    {/*
           <RadioButton
            ariaLabel="MIDLINE"
            name="midline"
            value={this.props.midLine}
            radios={midLineListButtons}
            handleChange={(e) => {
              this.props.handleDatamidLine(e.target.value)
            }}
            style={{ width: '100%'}}
          />
          */}

                    {this.midLineListButtons.map((v, index) => (
                        <Grid item xs={6} key={v.name}>
                            <FormControlLabel
                                key={v.name}
                                control={
                                    <Checkbox
                                        name={v.name}
                                        checked={this.props.midLine.includes(v.value) ? true : false}
                                        onChange={() =>
                                            this.props.mode !== 'view' && this.props.handleDatamidLine(v.value)
                                        }
                                    />
                                }
                                label={v.label}
                            />
                        </Grid>
                    ))}
                </div>

                <li>{this.get('questionnaire.crossbite')}</li>
                <div className={styles.radioWrapper}>
                    <RadioButton
                        ariaLabel="crossBite"
                        name="crossbite"
                        disabled={this.props.mode === 'view'}
                        value={this.props.crossBite}
                        radios={this.crossBiteRadioButtons}
                        handleChange={(e) => {
                            this.props.handleDatacrossBite(e.target.value);
                        }}
                    />
                </div>

                <li>{this.get('questionnaire.comment')}</li>
                <Grid item xs={12}>
                    <TextField
                        id="comment"
                        className={styles.textField}
                        value={this.props.comment ?? ''}
                        onChange={({ target: { value } }) =>
                            this.props.mode !== 'view' && this.props.handleDataComment(value)
                        }
                        margin="normal"
                        variant="outlined"
                        multiline
                        rows={4}
                        placeholder={this.get('questionnaire.comment')}
                    />
                </Grid>
            </ul>
        );
    }
}

const mapStateToProps = (store) => {
    return {
        extraction: store.newPatientReducer.extraction,
        expansion: store.newPatientReducer.expansion,
        extractionConcat: store.newPatientReducer.extractionConcat,
        expansionConcat: store.newPatientReducer.expansionConcat,
        interproximalReduction: store.newPatientReducer.interproximalReduction,
        distalization: store.newPatientReducer.distalization,
        proclination: store.newPatientReducer.proclination,
        treatmentSimulation: store.newPatientReducer.treatmentSimulation,
        overJet: store.newPatientReducer.overJet,
        overBite: store.newPatientReducer.overBite,
        midLine: store.newPatientReducer.midLine,
        crossBite: store.newPatientReducer.crossBite,
        comment: store.newPatientReducer.comment,
        clinicalConditionComment: store.newPatientReducer.clinicalConditionComment,
        teeth: store.newPatientReducer.teeth,
        clinical_condition: store.newPatientReducer.clinical_cond,
        lang: store.lang,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleDataExtraction: (value) => dispatch({ type: actionTypes.NEW_PATIENT_QUES_EXTRACTION, value: value }),
        handleDataExpansion: (value) => dispatch({ type: actionTypes.NEW_PATIENT_QUES_EXPANSION, value: value }),
        handleDataExtractionConcat: (value) =>
            dispatch({ type: actionTypes.NEW_PATIENT_QUES_EXTRACTION_CONCAT, value: value }),
        handleDataExpansionConcat: (value) =>
            dispatch({ type: actionTypes.NEW_PATIENT_QUES_EXPANSION_CONCAT, value: value }),
        handleDataInterproximalReduction: (value) =>
            dispatch({ type: actionTypes.NEW_PATIENT_QUES_INTER, value: value }),
        handleDataDistalization: (value) => dispatch({ type: actionTypes.NEW_PATIENT_QUES_DIST, value: value }),
        handleDataProclination: (value) => dispatch({ type: actionTypes.NEW_PATIENT_QUES_PROCLINATION, value: value }),
        handleDataTreatmentSimulation: (value) =>
            dispatch({ type: actionTypes.NEW_PATIENT_QUES_SIMULTAE, value: value }),
        handleDataOverJet: (value) => dispatch({ type: actionTypes.NEW_PATIENT_QUES_JET, value: value }),
        handleDataoverBite: (value) => dispatch({ type: actionTypes.NEW_PATIENT_QUES_BITE, value: value }),
        handleDatamidLine: (value) => dispatch({ type: actionTypes.NEW_PATIENT_QUES_MID, value: value }),
        handleDatacrossBite: (value) => dispatch({ type: actionTypes.NEW_PATIENT_QUES_ACROSS, value: value }),
        handleDataComment: (value) => dispatch({ type: actionTypes.NEW_PATIENT_QUES_COMMENT, value }),
        handleDatacrossTeeth: (value, force) =>
            dispatch({ type: actionTypes.NEW_PATIENT_QUES_TEETH, value: [value, force] }),
        changeClinicalCondition: (value) => dispatch({ type: actionTypes.CHANGE_CLINICAL_CONDITION, value: value }),
        handleClinicalConditionComment: (value) =>
            dispatch({ type: actionTypes.NEW_PATIENT_CLINICAL_CONDITION_COMMENT, value }),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(withLang(NewPatientQuestionnaire, 'NewPatient')));
